/* Shared by the local preview and the Shopify draft. */
(()=>{
 const selector='button,a[class*="button"],a[class*="btn"],a[class*="cta"],a[class*="__action"],a.cflive-shop,a.cp-buy,[role="button"]';
 const arrows=/[↗→➜➔➝⟶]/g;
 function clean(control){
  if(!control.textContent.replace(arrows,'').trim())return;
  control.classList.add('cf31-centered-control');
  const walker=document.createTreeWalker(control,NodeFilter.SHOW_TEXT);
  let node;while((node=walker.nextNode())){
   if(node.parentElement.closest('svg,script,style'))continue;
   const next=node.nodeValue.replace(arrows,'');
   if(next!==node.nodeValue){node.nodeValue=next;
    const parent=node.parentElement;
    if(parent!==control&&!parent.textContent.trim()&&!parent.children.length)parent.classList.add('cf31-decorative-arrow');
   }
  }
 }
 function scan(node){
  if(node.nodeType===Node.TEXT_NODE){const c=node.parentElement?.closest(selector);if(c)clean(c);return;}
  if(node.nodeType!==Node.ELEMENT_NODE)return;
  if(node.matches(selector))clean(node);
  node.querySelectorAll(selector).forEach(clean);
 }
 const style=document.createElement('style');style.textContent='.cf31-centered-control{justify-content:center!important;align-items:center!important;text-align:center!important}.cf31-decorative-arrow{display:none!important}';document.head.append(style);
 scan(document.body);
 new MutationObserver(records=>{for(const r of records){if(r.type==='characterData')scan(r.target);else r.addedNodes.forEach(scan);}}).observe(document.body,{childList:true,subtree:true,characterData:true});
})();
